import { HTTP } from '../../http-common'

export default {
  state: {
    loadedLinings: []
  },
  getters: {
    loadedLinings (state) {
      return state.loadedLinings
    }
  },
  mutations: {
    setLoadedLinings (state, payload) {
      state.loadedLinings = payload
    },
    createLining (state, payload) {
      state.loadedLinings.push(payload)
    },
    updateLining (state, payload) {
      state.loadedLinings = state.loadedLinings.map(lining => lining.id === payload.id ? payload : lining)
    },
    removeLining (state, id) {
      state.loadedLinings = state.loadedLinings.filter(lining => {
        return lining.id !== id
      })
    },
    clearLoadedLinings (state) {
      state.loadedLinings = []
    }
  },
  actions: {
    loadLinings ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedLinings', [])

      return new Promise((resolve, reject) => {
        HTTP.get('lining_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedLinings', result.data.results)
            commit('setLoading', false)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setLoading', false)
            commit('setError', err)
            reject(err)
          })
      })
    },
    createLining ({ commit, getters }, payload) {
      console.log('createLining')
      commit('clearError')
      commit('setLoading', true)
      const newLining = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('lining_type.json/', newLining)
          .then(result => {
            console.log(result)
            commit('createLining', result.data)
            commit('setLoading', false)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setLoading', false)
            commit('setError', err)
            reject(err)
          })
      })
    },
    updateLining ({ commit, getters }, payload) {
      console.log('updateLining')
      commit('clearError')
      commit('setLoading', true)
      const lining = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`lining_type.json/${payload.id}/`, lining)
          .then(result => {
            console.log(result)
            commit('updateLining', result.data)
            commit('setLoading', false)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setLoading', false)
            commit('setError', err)
            reject(err)
          })
      })
    },
    removeLining ({ commit }, payload) {
      console.log('removeLining')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`lining_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeLining', payload)
            commit('setLoading', false)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setLoading', false)
            commit('setError', err)
            reject(err)
          })
      })
    },
    clearLoadedLinings ({ commit }) {
      commit('clearLoadedLinings')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/lining/index.js